import { render } from "./FinishCard.vue?vue&type=template&id=2663ae2e"
import script from "./FinishCard.vue?vue&type=script&lang=js"
export * from "./FinishCard.vue?vue&type=script&lang=js"
script.render = render

export default script